import illustrationRetina from 'marketing-website/media/images/pages/ios-app-builder/builder-factory@2x.jpg';
import imageFilesRetina from 'marketing-website/media/images/pages/ios-app-builder/builder-one@2x.jpg';
import logosRetina from 'marketing-website/media/images/pages/ios-app-builder/builder-four@2x.jpg';
import devicesRetina from 'marketing-website/media/images/pages/ios-app-builder/builder-three@2x.jpg';
import generateApp from 'marketing-website/media/images/pages/ios-app-builder/builder-two@2x.png';

const assets = {
  illustration: {
    alt: 'iPhone/iPad app builder illustration',
    src: illustrationRetina,
    maxWidth: 800,
    hasShadow: false,
  },
  imageFiles: {
    alt: 'Image files illustration',
    src: imageFilesRetina,
    maxWidth: 280,
    hasShadow: false,
  },
  logosRetina: {
    alt: 'Integrations Logos',
    src: logosRetina,
    maxWidth: 273,
    hasShadow: false,
  },
  devicesRetina: {
    alt: 'Illustration of mobile devices',
    src: devicesRetina,
    maxWidth: 248,
    hasShadow: false,
  },
  generateApp: {
    alt: 'Generate app button',
    src: generateApp,
    maxWidth: 230,
    hasShadow: false,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/ios-app-builder/assets.js